import { render } from "./ForgotToroku.vue?vue&type=template&id=7e821336&scoped=true"
import script from "./ForgotToroku.vue?vue&type=script&lang=js"
export * from "./ForgotToroku.vue?vue&type=script&lang=js"

import "./ForgotToroku.vue?vue&type=style&index=0&id=7e821336&scoped=true&lang=css"

import exportComponent from "/Users/masayukitenma/Documents/Develop/Container/claudedocs/l13-check/fe-build/mobile_genba/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e821336"]])

export default __exports__